const input = {
    username: 'Username',
    password: 'Password',
    email: 'อีเมล',
    phone_number: 'หมายเลขโทรศัพท์',
    confirm_password: 'ยืนยันรหัสผ่าน',
    search_region_code: 'ค้นหารหัสภูมิภาค',
    backup_code: 'รหัสสำรอง',
    label_with_optional: '{{label}} (ไม่บังคับ)',
};
export default Object.freeze(input);
